import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import { Cell, Pie, PieChart } from "recharts";
import type { VIPDistribution } from "@/services/api";

const config: ChartConfig = {
  free: { label: "免费", color: "#94a3b8" },
  vip: { label: "VIP", color: "#f59e0b" },
  vvip: { label: "VVIP", color: "#8b5cf6" },
};

export function VIPDistributionChart({ data }: { data?: VIPDistribution }) {
  const chartData = data
    ? [
        { name: "免费", key: "free", value: data.free, fill: "var(--color-free)" },
        { name: "VIP", key: "vip", value: data.vip, fill: "var(--color-vip)" },
        { name: "VVIP", key: "vvip", value: data.vvip, fill: "var(--color-vvip)" },
      ].filter((d) => d.value > 0)
    : [];

  return (
    <Card>
      <CardHeader>
        <CardTitle>VIP 用户分布</CardTitle>
        <CardDescription>免费 / VIP / VVIP 占比</CardDescription>
      </CardHeader>
      <CardContent>
        {chartData.length > 0 ? (
          <ChartContainer config={config} className="h-[300px] w-full">
            <PieChart>
              <ChartTooltip content={<ChartTooltipContent nameKey="name" />} />
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                innerRadius={60}
                outerRadius={100}
                paddingAngle={2}
              >
                {chartData.map((entry) => (
                  <Cell key={entry.key} fill={entry.fill} />
                ))}
              </Pie>
              <ChartLegend content={<ChartLegendContent nameKey="name" />} />
            </PieChart>
          </ChartContainer>
        ) : (
          <div className="h-[300px] flex items-center justify-center text-muted-foreground">
            暂无数据
          </div>
        )}
      </CardContent>
    </Card>
  );
}
